import { ContextualMenu, getId, Icon, IDragOptions, Modal } from "@fluentui/react";
import { useState } from "react";
import FilterButton from "../../../common/views/FilterButton";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { MenuFilterType, MenuModel } from "../../models/CategoryModel";
import CategoryMenuItemView from "./CategoryMenuItemView";

export type SelectCategoryProps = {
    list: MenuModel[];
    getSelectedList: () => MenuModel[];
    onChecked: (category: MenuModel, checked: boolean) => void;
    onCollapsed: (category: MenuModel, collapsed: boolean) => void;
}

export default function SelectCategoryView({ list, getSelectedList, onChecked, onCollapsed }: SelectCategoryProps) {
    const [showMenu, setShowMenu] = useState(false);

    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const printSelectedTexts = () => {
        return getSelectedList()
            .map((item: MenuModel, index: number) => item.text)
            .join(", ");
    }

    const menuView = () => {
        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={showMenu}
                onDismiss={() => setShowMenu(false)}
                isBlocking={false}
                styles={StyleUtils.getModalWidthStyles(450)}
            >
                <ModalHeaderView title="Categories" onClose={() => setShowMenu(false)} />

                <div id={subtitleId} className="popup-body" style={{ height: "90vh", overflowY: "auto" }}>
                    <div>
                        <div className="pt-20">
                            {getSelectedList().map((item: MenuModel, index: number) => {
                                return <>
                                    <FilterButton
                                        text={item.text}
                                        onDelete={() => onChecked(item, false)}
                                    />
                                </>;
                            })}
                        </div>

                        {list
                            .filter(item => item.type !== MenuFilterType.brand)
                            .map((item: MenuModel, index: number) => {
                                return <>
                                    <CategoryMenuItemView
                                        item={item}
                                        hideZeroCount={false}
                                        onChecked={onChecked}
                                        onCollapsed={onCollapsed}
                                    />
                                </>
                            })}
                    </div>

                </div>
            </Modal>
        </>;
    }

    return <div>
        <div className="category-option pv-5">
            <label className="font-bolder">Categories</label>
        </div>
        <div className="brand-dropdown" onClick={() => setShowMenu(true)}>
            <div className="brand-dropdown-text">{printSelectedTexts()}</div>
            <div className="brand-dropdown-icon"><Icon iconName="ChevronDown" /></div>
        </div>

        {menuView()}
    </div>;
}